import { merchantTileListConfig as config } from '../configs';

const initialState = {
  config,
};

const merchantTileList = (state = initialState) => state;

export default merchantTileList;
